import React from 'react';
import { Mail } from 'lucide-react';

export default function ProfessionalGuidelinesPage() {
  return (
    <div className="min-h-screen py-12 px-4" style={{ backgroundColor: '#FDFBF7' }}>
      <div className="max-w-4xl mx-auto">
        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-8" style={{ color: '#2C3E50' }}>
            Normas para Profesionales
          </h1>

          <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
            Las presentes normas regulan la participación de profesionales y escuelas dentro del directorio <strong>Tantra Map</strong>.
          </p>
          <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
            Su objetivo es mantener una plataforma segura, respetuosa y alineada con la legislación vigente.
          </p>
          <p className="text-secondary mb-8" style={{ color: '#5D6D7E' }}>
            El registro y publicación de un perfil profesional implica la aceptación de estas normas.
          </p>

          {/* Section 1 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              1. Naturaleza de la plataforma
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Tantra Map es un <strong>directorio informativo de profesionales y escuelas relacionadas con el tantra</strong>.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La plataforma ofrece visibilidad y facilita el contacto entre usuarios y profesionales, pero <strong>no presta directamente servicios de masaje, terapia o formación</strong>.
            </p>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              2. Responsabilidad del profesional
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Cada profesional o escuela es el único responsable de:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>la veracidad de la información publicada</li>
              <li>los servicios que ofrece</li>
              <li>el cumplimiento de la legislación vigente en el lugar donde presta sus servicios</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web no verifica previamente todos los contenidos publicados.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              3. Información del perfil
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los profesionales deben proporcionar información real y actualizada.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              El perfil puede incluir:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>foto de perfil</li>
              <li>biografía profesional</li>
              <li>especialidades</li>
              <li>años de experiencia</li>
              <li>datos de contacto</li>
              <li>información sobre escuela o centro</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Está prohibido publicar información falsa, engañosa o que pueda inducir a error a los usuarios.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              4. Fotografías y material visual
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Las imágenes publicadas deben cumplir las siguientes normas:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>representar al profesional o su actividad real</li>
              <li>ser apropiadas y respetuosas</li>
              <li>no contener desnudos explícitos</li>
              <li>no mostrar contenido sexual o pornográfico</li>
              <li>no incluir material protegido por derechos de autor sin autorización</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular podrá eliminar imágenes que incumplan estas normas.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              5. Descripción de servicios
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Las descripciones de los servicios deben ser claras y honestas.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              No está permitido:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2" style={{ color: '#5D6D7E' }}>
              <li>utilizar lenguaje explícitamente sexual</li>
              <li>ofrecer servicios ilegales</li>
              <li>promocionar actividades que vulneren la legislación vigente</li>
            </ul>
          </section>

          {/* Section 6 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              6. Prohibición de servicios sexuales
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              La plataforma no permite la promoción de:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>prostitución</li>
              <li>servicios escort</li>
              <li>encuentros sexuales</li>
              <li>servicios sexuales explícitos</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Los perfiles que utilicen la plataforma para estos fines serán eliminados.
            </p>
          </section>

          {/* Section 7 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              7. Comportamiento profesional
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los profesionales se comprometen a mantener una conducta respetuosa hacia los usuarios de la plataforma.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              No se permite:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2" style={{ color: '#5D6D7E' }}>
              <li>acoso o comportamiento abusivo</li>
              <li>mensajes ofensivos</li>
              <li>prácticas engañosas o fraudulentas</li>
            </ul>
          </section>

          {/* Section 8 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              8. Moderación y eliminación de perfiles
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              El titular del sitio web se reserva el derecho de:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>modificar o eliminar contenidos que incumplan estas normas</li>
              <li>suspender o eliminar perfiles profesionales</li>
              <li>limitar el acceso a la plataforma en caso de uso indebido</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Estas medidas pueden aplicarse sin previo aviso cuando sea necesario para proteger el funcionamiento de la plataforma.
            </p>
          </section>

          {/* Section 9 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              9. Denuncia de contenido inapropiado
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Cualquier usuario puede comunicar contenidos inapropiados enviando un mensaje a:
            </p>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 inline-block mb-4">
              <a href="mailto:info@tantra-map.com" className="flex items-center gap-2 text-gold hover:underline font-semibold" style={{ color: '#D4A574' }}>
                <Mail className="h-5 w-5" />
                info@tantra-map.com
              </a>
            </div>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular revisará la solicitud y podrá adoptar las medidas necesarias.
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              10. Actualización de las normas
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Estas normas pueden actualizarse para adaptarse a cambios legales o al desarrollo de la plataforma.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Las modificaciones se publicarán en esta misma página.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
